import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20flat%20lay%20on%20white%20marble%20surface%20with%20soft%20diffused%20studio%20lighting%2C%20premium%20handbag%2C%20silk%20scarf%20and%20gold%20jewelry%20arranged%20in%20elegant%20composition%2C%20high-end%20lifestyle%20product%20photography%20with%20warm%20undertones%2C%20minimalist%20aesthetic%20with%20copy%20space%2C%20editorial%20catalog%20style&width=1800&height=700&seq=cta-section-hipobuy-01-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet lifestyle background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 leading-tight">
            Ready To Start Your{" "}
            <span className="text-accent-300">Smart Shopping</span> Journey?
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto leading-relaxed">
            Explore the Hipobuy Spreadsheet today and discover a better way to find, compare, and choose products across every category.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="group px-8 py-3.5 rounded-full text-sm font-semibold text-foreground-900 bg-accent-400 hover:bg-accent-300 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <div className="w-5 h-5 rounded-full bg-background-50 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-accent-600 text-xs"></i>
              </div>
              <span>Hipobuy Sheet</span>
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>

            <Link
              to="/hipobuy-spreadsheet-guide"
              className="group px-8 py-3.5 rounded-full text-sm font-semibold text-background-50 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span>Read Full Guide</span>
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}